export const dimensionScoreColumns = [
  {
    label: '维度名称',
    value: 'title',
    width: '500px'
  },
  {
    label: '操作',
    value: 'action',
    width: '90px'
  }
]

export const topicBindColumns = [
  {
    label: '维度名称',
    value: 'name',
    width: '275px'
  },
  {
    label: '题目数量',
    value: 'count',
    width: '120px'
  },
  {
    label: '题目内容',
    value: 'content',
    width: '275px'
  },
]

export const resultColumns = [
  {
    label: '分值范围',
    value: 'scoreRange',
    width: '150px'
  },
  {
    label: '评语建议',
    value: 'suggestion',
    width: '525px'
  },
  {
    label: '操作',
    value: 'action',
    width: '100px'
  },
]

export const dmResultColumns = [
  {
    label: '分值范围',
    value: 'scoreRange',
    width: '150px'
  },
  {
    label: '结果建议',
    value: 'suggestion',
    width: '525px'
  },
  {
    label: '操作',
    value: 'action',
    width: '100px'
  },
]
